// src/pages/Auth/Login.jsx

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase';
import toast from 'react-hot-toast';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [activeTab, setActiveTab] = useState('login');
    const navigate = useNavigate();

    // Personnel states
    const [personnelCompanyId, setPersonnelCompanyId] = useState('');
    const [personnelError, setPersonnelError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMsg('');
        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/dashboard');
        } catch (err) {
            setError('E-posta veya şifre hatalı.');
        }
        setLoading(false);
    };

    const handlePasswordReset = async () => {
        if (!email) { setError('Lütfen e-posta adresinizi girin.'); return; }
        try {
            await sendPasswordResetEmail(auth, email);
            setError('');
            setSuccessMsg('Şifre sıfırlama e-postası gönderildi.');
            toast.success('Şifre sıfırlama e-postası gönderildi!');
        } catch (err) {
            setError('Şifre sıfırlama e-postası gönderilemedi.');
        }
    };

    const handlePersonnelRegister = (e) => {
        e.preventDefault();
        setPersonnelError('');
        if (!personnelCompanyId) { setPersonnelError('Firma ID gereklidir.'); return; }
        navigate(`/register-personnel/${personnelCompanyId}/direct`);
    };

    return (
        <div className="auth-page" style={page}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
                @keyframes spin { to { transform: rotate(360deg); } }
                
                body { margin: 0; padding: 0; }
                
                .login-input:focus { border-color: #06C167 !important; box-shadow: 0 0 0 3px rgba(22,163,74,0.1) !important; }
                .login-btn:hover { background: #06C167 !important; }

                /* Mobil Uyumluluk */
                @media (max-width: 768px) {
                    .auth-page { flex-direction: column !important; min-height: 100vh !important; }
                    .left-panel { flex: none !important; padding: 40px 24px !important; text-align: center !important; align-items: center !important; }
                    .left-title { font-size: 28px !important; margin-bottom: 8px !important; }
                    .left-sub { font-size: 14px !important; margin-bottom: 16px !important; }
                    .feature-list { display: none !important; }
                    .left-footer { position: relative !important; bottom: auto !important; left: auto !important; margin-top: 16px !important; text-align: center; }
                    
                    .right-panel { padding: 30px 20px !important; align-items: flex-start !important; }
                    .form-container { max-width: 100% !important; }
                }
            `}</style>

            {/* Left — Branding Panel */}
            <div className="left-panel" style={leftPanel}>
                <div style={leftContent}>
                    <div style={logoBadge}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
                        </svg>
                    </div>
                    <h1 className="left-title" style={leftTitle}>On Muhasebe</h1>
                    <p className="left-sub" style={leftSub}>Sipariş, stok, fatura ve müşteri yönetimini tek platformda birleştirin.</p>

                    <div className="feature-list" style={featureList}>
                        {['Gerçek zamanlı stok takibi', 'Otomatik fatura oluşturma', 'Müşteri mutabakat raporları', 'Pazaryeri entegrasyonu'].map((f, i) => (
                            <div key={i} style={featureItem}>
                                <span style={checkIcon}>✓</span>
                                <span>{f}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <p className="left-footer" style={leftFooter}>© 2026 On Muhasebe</p>
            </div>

            {/* Right — Form Panel */}
            <div className="right-panel" style={rightPanel}>
                <div className="form-container" style={formContainer}>
                    <h2 style={formTitle}>
                        {activeTab === 'login' ? 'Hoş Geldiniz' : 'Personel Kayıt'}
                    </h2>
                    <p style={formSub}>
                        {activeTab === 'login'
                            ? 'Hesabınıza giriş yapın'
                            : 'Şirket yöneticinizden aldığınız Firma ID ile kayıt olun'}
                    </p>

                    {/* Tabs */}
                    <div style={tabRow}>
                        <button onClick={() => { setActiveTab('login'); setError(''); setPersonnelError(''); }}
                            style={activeTab === 'login' ? tabActive : tabInactive}>Giriş Yap</button>
                        <button onClick={() => { setActiveTab('personnel'); setError(''); setPersonnelError(''); }}
                            style={activeTab === 'personnel' ? tabActive : tabInactive}>Personel Kayıt</button>
                    </div>

                    {/* Login Form */}
                    {activeTab === 'login' && (
                        <form onSubmit={handleLogin}>
                            <div style={fieldGroup}>
                                <label style={label}>E-posta</label>
                                <input id="login-email" className="login-input" style={input} type="email"
                                    value={email} onChange={e => setEmail(e.target.value)}
                                    placeholder="ornek@firma.com" required />
                            </div>

                            <div style={fieldGroup}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <label style={label}>Şifre</label>
                                    <button type="button" onClick={handlePasswordReset} style={forgotBtn}>Şifremi Unuttum</button>
                                </div>
                                <div style={{ position: 'relative' }}>
                                    <input id="login-password" className="login-input" style={input}
                                        type={showPassword ? 'text' : 'password'}
                                        value={password} onChange={e => setPassword(e.target.value)}
                                        placeholder="••••••••" required />
                                    <button type="button" onClick={() => setShowPassword(!showPassword)} style={eyeBtn}>
                                        {showPassword ? '🙈' : '👁️'}
                                    </button>
                                </div>
                            </div>

                            {error && <div style={errBox}>{error}</div>}
                            {successMsg && <div style={okBox}>{successMsg}</div>}

                            <button id="login-submit" className="login-btn" type="submit" disabled={loading}
                                style={{ ...greenBtn, opacity: loading ? 0.7 : 1 }}>
                                {loading ? <><span style={spinner}/> Giriş yapılıyor...</> : 'Giriş Yap'}
                            </button>

                            <p style={footerText}>
                                Hesabınız yok mu?{' '}
                                <Link to="/register" style={greenLink}>Yeni Şirket Oluşturun</Link>
                            </p>
                        </form>
                    )}

                    {/* Personnel */}
                    {activeTab === 'personnel' && (
                        <form onSubmit={handlePersonnelRegister}>
                            <div style={fieldGroup}>
                                <label style={label}>Firma ID</label>
                                <input id="personnel-company-id" className="login-input" style={input} type="text"
                                    value={personnelCompanyId} onChange={e => setPersonnelCompanyId(e.target.value)}
                                    placeholder="Yöneticinizden aldığınız kodu girin" required />
                            </div>
                            {personnelError && <div style={errBox}>{personnelError}</div>}
                            <button id="personnel-submit" className="login-btn" type="submit" style={greenBtn}>
                                Devam Et →
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}

// ---- Uber-inspired white + green styles ----
const page = {
    display: 'flex', minHeight: '100vh', fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
};

const leftPanel = {
    flex: '0 0 42%', background: 'linear-gradient(160deg, #166534, #06C167 40%, #06C167)',
    display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '60px 48px',
    position: 'relative', overflow: 'hidden'
};

const leftContent = { position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column' };

const logoBadge = {
    width: '56px', height: '56px', borderRadius: '14px',
    background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '28px'
};

const leftTitle = {
    fontSize: '36px', fontWeight: '800', color: 'white', margin: '0 0 12px', letterSpacing: '-1px'
};

const leftSub = {
    fontSize: '16px', color: 'rgba(255,255,255,0.8)', lineHeight: '1.6', margin: '0 0 36px', maxWidth: '340px'
};

const featureList = { display: 'flex', flexDirection: 'column', gap: '14px' };

const featureItem = {
    display: 'flex', alignItems: 'center', gap: '12px', color: 'rgba(255,255,255,0.9)', fontSize: '14px', fontWeight: '500'
};

const checkIcon = {
    width: '22px', height: '22px', borderRadius: '50%',
    background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '12px', color: 'white', fontWeight: '700', flexShrink: 0
};

const leftFooter = {
    position: 'absolute', bottom: '32px', left: '48px', color: 'rgba(255,255,255,0.4)', fontSize: '12px'
};

const rightPanel = {
    flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#ffffff', padding: '40px'
};

const formContainer = { width: '100%', maxWidth: '380px' };

const formTitle = {
    fontSize: '28px', fontWeight: '700', color: '#111827', margin: '0 0 4px', letterSpacing: '-0.5px'
};

const formSub = { fontSize: '14px', color: '#6b7280', margin: '0 0 28px' };

const tabRow = {
    display: 'flex', gap: '4px', padding: '4px',
    background: '#f3f4f6', borderRadius: '10px', marginBottom: '28px'
};

const tabActive = {
    flex: 1, padding: '10px', border: 'none', borderRadius: '8px', fontSize: '13px',
    fontWeight: '600', cursor: 'pointer', background: 'white', color: '#111827',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)', transition: 'all 0.2s', fontFamily: 'inherit'
};

const tabInactive = {
    flex: 1, padding: '10px', border: 'none', borderRadius: '8px', fontSize: '13px',
    fontWeight: '500', cursor: 'pointer', background: 'transparent', color: '#9ca3af',
    transition: 'all 0.2s', fontFamily: 'inherit'
};

const fieldGroup = { marginBottom: '20px' };

const label = {
    display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151'
};

const input = {
    width: '100%', padding: '13px 14px', fontSize: '14px', fontFamily: 'inherit',
    border: '1.5px solid #e5e7eb', borderRadius: '10px', boxSizing: 'border-box',
    outline: 'none', transition: 'all 0.2s', background: '#fafafa', color: '#111827'
};

const eyeBtn = {
    position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px', padding: '4px'
};

const forgotBtn = {
    background: 'none', border: 'none', color: '#06C167', fontSize: '12px',
    cursor: 'pointer', fontWeight: '600', padding: 0, fontFamily: 'inherit'
};

const greenBtn = {
    width: '100%', padding: '14px', border: 'none', borderRadius: '10px',
    background: '#06C167', color: 'white', fontSize: '15px', fontWeight: '700',
    cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'inherit',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
};

const errBox = {
    padding: '10px 14px', borderRadius: '8px', marginBottom: '16px',
    background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: '13px', textAlign: 'center'
};

const okBox = {
    padding: '10px 14px', borderRadius: '8px', marginBottom: '16px',
    background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#06C167', fontSize: '13px', textAlign: 'center'
};

const footerText = { textAlign: 'center', marginTop: '20px', color: '#9ca3af', fontSize: '13px' };

const greenLink = { color: '#06C167', textDecoration: 'none', fontWeight: '600' };

const spinner = {
    display: 'inline-block', width: '16px', height: '16px',
    border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white',
    borderRadius: '50%', animation: 'spin 0.6s linear infinite'
};

export default Login;
